<template>
  <div>
    <v-text-field :label="label" @click="pickFile" v-model="fileName" prepend-icon="attach_file" persistent-hint :hint="`Maximum file size is ${ this.maxMB }MB`"></v-text-field>
    <input
      type="file"
      ref="file"
      style="display: none"
      @change="onFilePicked"
      :accept="accept">
    </input>
    <v-progress-linear v-show="uploadPercentage > 0 && uploadPercentage !== 100" v-model="uploadPercentage"></v-progress-linear>

  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'Uploader',
    props: {
      accept: {
        type: String,
        default: 'image/*'
      },
      apiUrl: {
        type: String,
        default: '/uploads'
      },
      maxMB: {
        type: Number,
        default: 15,
      },
    },
    data() {
      return {
        file: null,
        presigned: {},
        uploadPercentage: 0,
        fileName: '',
      }
    },
    computed: {
      label: function() {
        if (this.fileName.length > 0) {
          return 'Change file...'
        } else {
          return 'Choose file...'
        }
      }
    },
    methods: {
      pickFile () {
        this.$refs.file.click()
      },
      onFilePicked (e) {
        let vm = this;
        let file = vm.$refs.file.files[0] // only getting first...
        this.file = file
        this.fileName = file.name

        vm.$emit('presigned', {}) // clear presigned in the case of new image chosen
        this.$store.commit('uploader/setFilename', this.fileName)

        let formData = new FormData;
        formData.append('upload[file]', file);

        if ((file.size / 1024 / 1024) > this.maxMB) {
          alert(`That file is too large. Must be less than ${ this.maxMB }MB`)
          vm.uploadPercentage = 0
          this.file = null
          this.fileName = ''
          vm.$emit('presigned', null)
          vm.$emit('done');
          return
        }

        // TODO: move to api module
        axios.post('/uploads', formData, {
          onUploadProgress: function (progressEvent) {
            vm.$emit('uploading');
            vm.uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(progressEvent.loaded * 100)
          }
          })
          .then(resp => {
            vm.$emit('presigned', resp.data)
          })
          .catch(function (errors) {
            console.log(errors)
          })
          .finally(resp => {
            vm.uploadPercentage = 0
            vm.$emit('done');
          })
        this.toDataUrl()
      },
      toDataUrl() {
        let vm = this;
        let reader = new FileReader();
        reader.addEventListener("load", function () {
          let dataUrl = reader.result;
          vm.$emit('image', dataUrl);
          vm.$store.commit('uploader/setImage', dataUrl)
        }.bind(vm), false);
        if (/\.(jpe?g|png|gif)$/i.test(vm.file.name)) {
          reader.readAsDataURL(vm.file);
        }
      }
    }
  }
</script>

